import { APP_NAME } from "./general"

const Text = {
    "message_inscription" : "Votre inscription sur " + APP_NAME + " s'est bien déroulée, Veuillez valider votre adresse email."
}

export { Text }